import { render, staticRenderFns } from "./newsletterHS.vue?vue&type=template&id=2328511b"
import script from "./newsletterHS.vue?vue&type=script&lang=js"
export * from "./newsletterHS.vue?vue&type=script&lang=js"
import style0 from "./newsletterHS.vue?vue&type=style&index=0&id=2328511b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports